/* Mattress covers: colour picker and "Add to cart" on the Mattress Covers page (sections/tt-cover-showcase.liquid)
   and on a cover's product page (snippets/tt-cart-only-note.liquid). The add button is only rendered when a teepee
   the cover fits is in the cart; the line gets "_addon_for" = that teepee, so it's removed with the teepee. */
(function () {
	if (window.ttCoverShowcase) return;
	window.ttCoverShowcase = true;

	// Prices come from the money filter, which the CVC Multi Currency app wraps in <span class=cvc-money>.
	const setPrice = (el, html) => {
		if (/^(<span class=["']?cvc-money["']?>[^<]*<\/span>|[^<]*)$/.test(html.trim())) el.innerHTML = html;
		else el.textContent = html.replace(/<[^>]*>/g, '');
	};

	document.addEventListener('change', (event) => {
		const input = event.target.closest('.tt-cover__swatch input');
		if (!input) return;
		const card = input.closest('[data-tt-cover]');
		const add = card.querySelector('[data-tt-cover-add]');
		if (add) add.dataset.variantId = input.value;
		card.querySelector('[data-tt-cover-colour]').textContent = input.dataset.title;
		setPrice(card.querySelector('[data-tt-cover-price]'), input.dataset.price);
		const img = card.querySelector('[data-tt-cover-img]');
		if (img && input.dataset.img) {
			img.removeAttribute('srcset');
			img.src = input.dataset.img;
		}
		const link = card.querySelector('[data-tt-cover-link]');
		if (link) link.href = link.href.split('?')[0] + '?variant=' + input.value;
	});

	document.addEventListener('click', async (event) => {
		const button = event.target.closest('[data-tt-cover-add]');
		if (!button || button.disabled) return;
		const box = button.closest('[data-tt-cover]');
		const error = box && box.querySelector('[data-tt-cover-error]');
		// On the product page the colour comes from the page's own variant picker (it keeps ?variant= in the URL).
		let variantId = button.dataset.variantId;
		if (button.hasAttribute('data-variant-from-url')) {
			const fromUrl = new URL(window.location.href).searchParams.get('variant');
			if (fromUrl) variantId = fromUrl;
		}
		const drawer = document.querySelector('cart-drawer');
		const sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender().map((s) => s.id) : [];
		button.disabled = true;
		button.classList.add('loading');
		if (error) error.hidden = true;
		try {
			const response = await fetch(`${window.routes.cart_add_url}.js`, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
				body: JSON.stringify({
					items: [{ id: Number(variantId), quantity: 1, properties: { _addon_for: button.dataset.addonFor } }],
					sections,
					sections_url: window.location.pathname,
				}),
			});
			const state = await response.json();
			if (!response.ok || state.status) throw new Error(state.description || state.message || 'Could not add to cart');
			if (drawer && typeof drawer.renderContents === 'function') drawer.renderContents(state);
			else window.location.href = window.routes.cart_url;
		} catch (e) {
			if (error) {
				error.textContent = e.message || 'Something went wrong. Please try again.';
				error.hidden = false;
			}
		} finally {
			button.disabled = false;
			button.classList.remove('loading');
		}
	});
})();
